import { useEffect, useState } from "react";
import { UsendLoadingMark } from "../loader/UsendMarks";
import { CHECK, Svg } from "./parts";
import styles from "./welcome.module.css";

const STEPS = ["Shopify access granted", "Setting up fulfillment service", "Creating your workspace"];

// Shown on /install and /auth while the store connects. The steps are not tracked one by
// one by the server, so they advance on a timer and the last one keeps spinning until the
// page redirects.
export default function ConnectingStore({ shop }) {
  const [done, setDone] = useState(0);

  useEffect(() => {
    const timers = [setTimeout(() => setDone(1), 700), setTimeout(() => setDone(2), 1900)];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <main className={styles.page}>
      <section className={`${styles.card} ${styles.plain}`} role="status" aria-live="polite">
        <div className={styles.staticLogo}>
          <UsendLoadingMark size={96} />
        </div>
        <h1>Connecting your store</h1>
        {shop && <p className={styles.lead}>{shop}</p>}
        <ul className={styles.status}>
          {STEPS.map((label, i) => {
            const state = i < done ? "done" : i === done ? "busy" : "todo";
            return (
              <li key={label} data-state={state}>
                <span className={styles.dot}>{state === "done" && <Svg d={CHECK} />}</span>
                {label}
              </li>
            );
          })}
        </ul>
      </section>
    </main>
  );
}
